<template>
    <div class="page-wrap">
        <div class="page-bar">
            <div>
                <div class="page-bar-sub">Team</div>
                <div class="page-bar-main">Skills Matrix</div>
            </div>
        </div>
        <div :class="$store.state.routeLoaded ? 'slide-up view' : 'hide'">
            <div v-if="$store.state.user.teamHubRole == 'Admin'" class="page-filters pf-bar">
                <forge-page-button :kinds="['skills']" label="Build with AI" @applied="getMatrices()" />
                <div @click="() => { showAddMatrix = true }" class="add-btn">Add</div>
            </div>
            <div>
                <div class="next-nodes-grid">
                    <div v-for="(matrix, i) in matrices" :key="i" class="next-node-card-wrap">
                        <div class="next-node-card" @click="() => { $router.push('/skills-matrix/'+matrix.ID) }">
                            <div class="next-node-card-top">
                                <div class="next-node-card-name">{{ matrix.Name }}</div>
                                <button v-if="$store.state.user.teamHubRole == 'Admin'" type="button" class="next-node-menu-btn" @click.stop="toggleMatrixMenu(matrix, $event)">
                                    <svg-icon icon="dots" />
                                </button>
                            </div>
                        </div>
                        <div v-if="openMatrixId == matrix.ID" class="next-node-menu-dropdown" :style="matrixMenuStyle" @click.stop>
                            <router-link :to="'/skills-matrix/'+matrix.ID+'?edit=t'" @click="closeMatrixMenu">Edit</router-link>
                            <a @click.prevent="matrixMenuAction(() => deleteMatrix(matrix))">Delete</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <add-edit-skills-matrix v-if="showAddMatrix" @close="() => { showAddMatrix = false; getMatrices() }" />
        <confirm-delete v-if="showConfirmDelete" @confirm="deleteConfirm" @cancel="() => { showConfirmDelete = false; }" msg="Are you sure you would like to delete this skills matrix?"/>
    </div>
</template>

<script lang="ts">
import { defineComponent, registerRuntimeCompiler } from 'vue';
import axios from 'axios';
import ConfirmDelete from '@/components/ConfirmDelete.vue';
import AddEditSkillsMatrix from '@/components/AddEditSkillsMatrix.vue';
import SvgIcon from '@/components/SvgIcon.vue';
import ForgePageButton from '@/components/ForgePageButton.vue';

export default defineComponent({
    name: 'OnboardingsView',
    components: {
        ConfirmDelete,
        AddEditSkillsMatrix,
        SvgIcon,
        ForgePageButton
    },
    data() {
        return {
            matrices: [] as any,
            matrixIdToDelete: null as any,
            showConfirmDelete: false,
            showAddMatrix: false,
            openMatrixId: null as any,
            matrixMenuStyle: {} as any
        }
    },
    async created() {
        await this.getMatrices();

        this.$store.state.routeLoaded = true;
    },
    methods: {
        async getMatrices() {
            await axios.get(`${this.$store.state.apiUrl}/api/skillsmatrices`)
                .then(resp => {
                    this.matrices = resp.data;
                })
                .catch(e => {
                    console.log(e);
                })
        },
        deleteMatrix(matrix: any) {
            this.matrixIdToDelete = matrix.ID;
            this.showConfirmDelete = true;
        },
        deleteConfirm() {
            this.showConfirmDelete = false;
            axios.delete(`${this.$store.state.apiUrl}/api/skillsmatrices/${this.matrixIdToDelete}`)
                .then(resp => {
                    this.getMatrices();
                })
                .catch(e => {
                    console.log(e);
                    alert('There was an error')
                })
        },
        toggleMatrixMenu(matrix: any, event: MouseEvent) {
            if(this.openMatrixId == matrix.ID) {
                this.openMatrixId = null;
                return;
            }

            const margin = 10;
            const dropdownWidth = 200;
            const btn = event.currentTarget as HTMLElement;
            const wrap = btn.closest('.next-node-card-wrap') as HTMLElement;
            const rect = btn.getBoundingClientRect();
            const wrapRect = wrap.getBoundingClientRect();

            const top = Math.min(rect.bottom + 6, window.innerHeight - margin);

            this.matrixMenuStyle = {
                top: (top - wrapRect.top) + 'px',
                left: '-10px',
                width: dropdownWidth + 'px',
                maxHeight: (window.innerHeight - top - margin) + 'px'
            };
            this.openMatrixId = matrix.ID;
        },
        closeMatrixMenu() {
            this.openMatrixId = null;
        },
        matrixMenuAction(action: any) {
            this.closeMatrixMenu();
            action();
        },
        handleOutsideMatrixMenuClick(e: MouseEvent) {
            if(this.openMatrixId && !(e.target as HTMLElement).closest('.next-node-card-wrap')) {
                this.openMatrixId = null;
            }
        }
    },
    mounted() {
        document.addEventListener('click', this.handleOutsideMatrixMenuClick);
        window.addEventListener('resize', this.closeMatrixMenu);
    },
    beforeUnmount() {
        document.removeEventListener('click', this.handleOutsideMatrixMenuClick);
        window.removeEventListener('resize', this.closeMatrixMenu);
    }
});
</script>
